const transferStationRouter = [
  // 上传图片首页
  {
    path: "/transfer-station/upload-portrait/index",
    name: 'upload-portrait-index',
    component: () => import('../views/transfer-station/upload-portrait/index'),
    meta: {
			isLogin: false
		}
  },
  // 上传图片 check 页
  {
    path: "/transfer-station/upload-portrait/check",
    name: 'upload-portrait-check',
    component: () => import('../views/transfer-station/upload-portrait/check'),
    meta: {
			isLogin: false
		}
  },
  // 上传图片 success 页
  {
    path: "/transfer-station/upload-portrait/success",
    name: 'upload-portrait-success',
    component: () => import('../views/transfer-station/upload-portrait/success'),
    meta: {
			isLogin: false
		},
  },
  // 证件照编辑
  {
    path: "/transfer-station/photo-make-start",
    name: 'photo-make-start',
    component: () => import('../views/transfer-station/photo-make/start'),
    meta: {
      isLogin: false
    },
  }
]

export default transferStationRouter
